let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cTfQX")).then(() => parcelRequire('5ATSG'));